import { numbers } from './numbers';
import { stats } from './stats';

export const call_tracking = {
  namespaced: true,
  modules: {
    numbers,
    stats
  }
};
